function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogoTtamayoVertical = function SvgLogoTtamayoVertical(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 98.88 160"
  }, props), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m67.97 31.41 9.36-26.6 9.36 26.6zM98.88 0v45.51L82.46 0zM77.33 61.46l9.36 26.6H67.97zM75.41 154.77c-11.27 0-17.46-8.91-17.46-18.63s6.19-19.31 17.46-19.31 17.32 9.66 17.32 19.31-6.2 18.63-17.32 18.63M0 112.31l20.65 28.76V160H0z",
    style: {
      fill: "#3232c8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m72.39 56.32-17.68 49h7.22l3.83-11H88.9l3.9 11h6.08v22.75c-2.95-10.13-11.51-17.71-23.47-17.71-14.74 0-24.76 11.86-24.76 25.71 0 11.12 6.13 20.63 16.45 23.94H27.72v-18.94l21.37-29.77h-8.65l-16.25 22.64L7.94 111.3H0v-6h6.21V63.39l13.56 31.09h8.76l13.56-31.09v41.92H49v-49H37.74L24.26 87.92l-13.63-31.6H0V6.07h10.12v42.58h7.07V6.07h14.15v42.58h7.07V6.07h15.25V0h18.61L54.71 48.65h7.22l3.83-11H88.9l3.9 11h6.08v53.52L82.34 56.32ZM98.88 143.92V160H83.49a23.71 23.71 0 0 0 15.39-16.08",
    style: {
      fill: "#3232c8"
    }
  }))));
};
export default SvgLogoTtamayoVertical;